
import React from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Tab, Nav } from "react-bootstrap";
import SnowLoad from "../../ControlPanel/Common/SnowLoad";
import AddLTExtension from "./AddLTExtension.js";
import { ShowBuildingImage } from "../../../Intel/defaultBuilding/defaultbuilding.helper.js";
import { const_var } from "../../../redux/reducers/reducer.js";
import { commonConfirmationAlert, getSelectedTab, handleAccordion } from "../../../action/index.js";
import { buildingStyleChangeAccordingtoType } from "../../../action/building/building_style/buildingStyle.action.js";
let cutomBuildingData = {};

const getDimensions = (c_m_a, val) => {
	let dimensionsDataW = 0;
	let dimensionsDataL = 0;
	let dimensionsDataH = 0;

	if (c_m_a[val.building_id] != undefined) {
		const roofStyle = c_m_a?.[val.building_id]?.roof_style || [];
		const findIndex = Array.isArray(roofStyle) && roofStyle.length > 0 ? roofStyle.findIndex((data) => data.roof_id == val.roof_id) : 2;
		let selectedRoofStyle = roofStyle[0];
		if (roofStyle.length == 3) {
			selectedRoofStyle = roofStyle[findIndex];

		} else if (c_m_a[val.building_id].roof_style != undefined && c_m_a[val.building_id].roof_style.length == 2) {
			selectedRoofStyle = roofStyle[1];

		} else {
			selectedRoofStyle = roofStyle[0];

		}
		dimensionsDataW = selectedRoofStyle.min_width + "'-" + selectedRoofStyle.max_width + "'";
		dimensionsDataL = selectedRoofStyle.start_length + "'-" + selectedRoofStyle.building_max_length + "'";
		dimensionsDataH = selectedRoofStyle.min_height + "'-" + selectedRoofStyle.max_height + "'";
	}
	return {
		dimensionsDataW,
		dimensionsDataL,
		dimensionsDataH
	};
};

const DimensionList = ({ dimensionsDataW, dimensionsDataL, dimensionsDataH }) => {
	return (
		<ul className="dimension">
			<li className="item-dimension">
				<span className="dimension-label">W</span>
				<span className="dimension-value">{dimensionsDataW}</span>
			</li>

			<li className="item-dimension">
				<span className="dimension-label">L</span>
				<span className="dimension-value">{dimensionsDataL}</span>
			</li>

			<li className="item-dimension">
				<span className="dimension-label">H</span>
				<span className="dimension-value">{dimensionsDataH}</span>
			</li>
		</ul>
	);
};

const SavingSpinner = ({ is_loader }) => {
	return (
		<span className={is_loader == true ? "active saving-effect saving-effect-type-2 disabled" : "saving-effect saving-effect-type-2"}>
			<span></span>
			<span></span>
			<span></span>
		</span>
	);
};

const BuildingTabNav = ({ id, eventKey, label, getActiveTab, customClass = "" }) => {
	const dispatch = useDispatch();
	const { const_var } = useSelector(state => state.reducer);
	return (
		<Nav.Item className="nav-item-pill" id={id}>
			<Nav.Link
				eventKey={eventKey}
				onClick={(e) => {
					dispatch(handleAccordion(e));

					if (eventKey == "customizations") {
						dispatch(commonConfirmationAlert("customBuilding"));
					} else {
						const_var.eventKey = eventKey;
					}
					getActiveTab(id, eventKey);
				}}
				className={customClass ? customClass : const_var.checkmoreCustomizeFlag == true ? "nav-link-badge disabled" : "nav-link-badge"}
			>
				{label}
			</Nav.Link>
		</Nav.Item>
	);
};

const BuildingCard = ({ val, index, buildingList, newClass, isLTShape = false }) => {
	const { params, c_m_a } = useSelector(state => state.reducer);
	const dispatch = useDispatch();
	let showFLag = true;
	if (c_m_a[val.building_id] == undefined) {
		showFLag = false;
	}
	if (const_var.loginSession == false && val.name == "Custom Buildings") {
		showFLag = false;
	}
	const splitVal = val.other_building_id.split(",");
	if (val.name == "Custom Buildings") {
		cutomBuildingData.id = val.id;
		cutomBuildingData.splitId = splitVal;
	}
	if (params.p_s_n == "29" && params.m_s_n == "122" && params.isSnowLoad == true && val.name == "Standard Barns") {
		return null;
	}
	if (val.is_show != undefined || showFLag == false) {
		return null;
	}
	const { dimensionsDataW, dimensionsDataL, dimensionsDataH } = getDimensions(c_m_a, val);
	let isActive = false;
	if (isLTShape == true) {
		isActive = val.id == const_var.selectedBuildingUniqId;
	} else {
		isActive = val.other_building_id.includes(params.p_b_t) == true && val.id == const_var.selectedBuildingUniqId;
	}

	return (
		<>
			{val.name != "Custom Buildings" && (
				<label className={isActive ? "box-item active" + newClass : "box-item " + newClass} key={index}>
					<div className={`media-box ${index == buildingList.length - 2 ? " no-border-btm" : ""}`}>
						<ShowBuildingImage src={val?.image_url} />
						<div className="media-body">
							<strong className="media-title">{val.name}</strong>
							<DimensionList dimensionsDataW={dimensionsDataW} dimensionsDataL={dimensionsDataL} dimensionsDataH={dimensionsDataH} />
						</div>

						<div onClick={() => dispatch(getSelectedTab("buildsizes"))} className="checkmark">
							<span className="icon icon-checkmark-ico"></span>
						</div>

						<input
							type="radio"
							name="options"
							value={val.id}
							onClick={(e) => {
								if (const_var.is_loader == false) {
									dispatch(buildingStyleChangeAccordingtoType(e.target.value, splitVal));
								}
							}}
						/>
					</div>
				</label>
			)}
		</>
	);
};

const BuildingPane = ({ eventKey, buildingList, newClass, isLTShape = false }) => {
	const {const_var} = useSelector(state=>state.reducer);
	return (
		<Tab.Pane eventKey={const_var.checkmoreCustomizeFlag == true ? "" : eventKey}>
			<div className="box-grid">
				{buildingList.map((val, index) => {
					return <BuildingCard key={index} val={val} index={index} buildingList={buildingList} newClass={newClass} isLTShape={isLTShape} />;
				})}

				<SavingSpinner is_loader={const_var.is_loader} />
			</div>
		</Tab.Pane>
	);
};

const BuildingStyle = () => {
	const {const_var,params,defaultBuilding,checkedBuildingType,isShowPredesignOption} = useSelector(state=>state.reducer);
	const { isShowUpdatedBuildingImages, crmSetting } = const_var;

	let carportsBuilding = const_var.defaultBuildingArr.filter((item) => item?.name?.includes("Carport") || item?.name?.includes("Standard"));

	let garagesdBuilding = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype?.name?.includes("Garage"));

	let commercialBuilding = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype?.name?.includes("Commercial"));

	let barnsBuilding = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype?.name?.includes("Barn"));

	let rvcoverBuilding = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype?.name?.includes("RV"));

	let freestandingBuilding = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype?.name?.includes("Standing"));

	let breezewayBuilding = const_var.defaultBuildingArr.filter((checkbuildtype) => checkbuildtype?.name?.includes("Breezeway"));

	let newClass = "";

	if (const_var.isCheckDisabled == true || const_var.is_loader == true) {
		newClass = " disabled";
	}

	let customBuildingFlag = true;

	if (const_var.loginSession == false) {
		customBuildingFlag = const_var.is_custom_building != undefined ? const_var.is_custom_building : false;
	}

	let parseVal = parseInt(defaultBuilding);
	let chkVariable = parseInt(defaultBuilding);

	if (defaultBuilding != undefined) {
		const filterRecord = const_var.defaultBuildingArr.filter((data) => data.building_id == checkedBuildingType && const_var.defaultBuildingArr[parseVal].image_name == data.image_name);

		if (filterRecord.length > 0) {
			chkVariable = filterRecord[0].id;
		}
	}

	
	// LT Shape Logic
	

	const LTshapeBuilding = [];

	const LBuilding = const_var.defaultBuildingArr.find((building) => building?.name?.includes("L") && building?.name?.toLowerCase()?.includes("shape"));

	const TBuilding = const_var.defaultBuildingArr.find((building) => building?.name?.includes("T") && building?.name?.toLowerCase()?.includes("shape"));

	const FBBuilding = const_var.defaultBuildingArr.find((building) => building?.name?.toLowerCase()?.includes("front") && building?.name?.toLowerCase()?.includes("back"));

	const doesLBuildingHasGabbleMapping = const_var?.c_m_a?.[LBuilding?.building_id]?.gable_mapping?.[0]?.map_id;

	const doesTBuildingHasGabbleMapping = const_var?.c_m_a?.[TBuilding?.building_id]?.gable_mapping?.[0]?.map_id;

	const doesFBBuildingHasGabbleMapping = const_var?.c_m_a?.[FBBuilding?.building_id]?.gable_mapping?.[0]?.map_id;

	if (doesTBuildingHasGabbleMapping) LTshapeBuilding.push(TBuilding);

	if (doesLBuildingHasGabbleMapping) LTshapeBuilding.push(LBuilding);

	if (doesFBBuildingHasGabbleMapping) LTshapeBuilding.push(FBBuilding);

	if (const_var?.isLTEnableForMfg == false && const_var.eventKey === "LTshape" && LTshapeBuilding.length > 0) {
		const_var.eventKey = "garages";
	}

	
	// Tab Scroll
	
	const getActiveTab = (tabid, tabname) => {
		let goTo = document.getElementById(tabid);

		let container = document.querySelector(".buildingtype-nav");

		let activeTabPosition = goTo.offsetLeft + goTo.offsetWidth;

		let containerScroll = container.scrollLeft + container.offsetWidth;

		if (activeTabPosition > containerScroll) {
			let moveTo = container.offsetWidth + goTo.offsetWidth;

			container.scrollTo({
				left: moveTo,
				behavior: "smooth"
			});
		}

		if (goTo.offsetLeft < container.scrollLeft) {
			let moveTo = container.scrollLeft - goTo.offsetWidth;

			container.scrollTo({
				left: moveTo,
				behavior: "smooth"
			});
		}
	};

	return (
		<>
			<div className="building-elements-sec deposit-section">
				<div className="building-elements-sec-mid pt-0">
					<div className="building-elements-sec-mid-scroll">
						<form>
							<div className={`section-seprator ${const_var.checkmoreCustomizeFlag == true ? "for-disable-section" : ""}`}>
								<Tab.Container className={`w-full accordion-type-2 ${isShowPredesignOption == true ? "pb-0" : "pb-5"}`} defaultActiveKey="garages" activeKey={const_var.eventKey}>
									{const_var.CheckSnowLoadFlag == true ? (
										<div className="snow-load">
											<SnowLoad />
										</div>
									) : null}

									{/* ---------------------------------------------------------------- */}
									{/* Nav */}
									{/* ---------------------------------------------------------------- */}

									<Nav variant="pills" className="nav-pill-badge buildingtype-nav">
										{carportsBuilding.length > 0 ? <BuildingTabNav id="tab11" eventKey="carports" label="Carports" getActiveTab={getActiveTab} /> : null}

										{garagesdBuilding.length > 0 ? <BuildingTabNav id="tab12" eventKey="garages" label="Garages" getActiveTab={getActiveTab} /> : null}

										{commercialBuilding.length > 0 ? <BuildingTabNav id="tab13" eventKey="commercial" label="Commercials" getActiveTab={getActiveTab} /> : null}

										{barnsBuilding.length > 0 ? <BuildingTabNav id="tab14" eventKey="barns" label="Barns"  getActiveTab={getActiveTab} /> : null}

										{const_var?.isLTEnableForMfg && LTshapeBuilding.length > 0 ? (
											<BuildingTabNav id="tab18" eventKey="LTshape" label="L & T Shape"  getActiveTab={getActiveTab} />
										) : null}

										{rvcoverBuilding.length > 0 ? <BuildingTabNav id="tab15" eventKey="rvcover" label="RV Covers"  getActiveTab={getActiveTab} /> : null}

										{freestandingBuilding.length > 0 ? <BuildingTabNav id="tab16" eventKey="freestanding" label="Free Standings" getActiveTab={getActiveTab} /> : null}

										{customBuildingFlag == true && isShowPredesignOption == true ? (
											<BuildingTabNav
												id="tab17"
												eventKey="customizations"
												label={
													<>
														<span className="icon">
															<i className="icon-customization-ico"></i>
														</span>

														<span className="text">More Customizations</span>
													</>
												}
												getActiveTab={getActiveTab}
												customClass="nav-link-badge customization"
											/>
										) : null}
									</Nav>

									{/* Tab Content */}
									<Tab.Content>
										{carportsBuilding.length > 0 ? <BuildingPane eventKey="carports" buildingList={carportsBuilding} newClass={newClass} /> : null}

										{garagesdBuilding.length > 0 ? <BuildingPane eventKey="garages" buildingList={garagesdBuilding}  newClass={newClass} /> : null}

										{commercialBuilding.length > 0 ? <BuildingPane eventKey="commercial" buildingList={commercialBuilding} newClass={newClass} /> : null}

										{barnsBuilding.length > 0 ? <BuildingPane eventKey="barns" buildingList={barnsBuilding} newClass={newClass} /> : null}

										{const_var?.isLTEnableForMfg && LTshapeBuilding.length > 0 ? (
											<BuildingPane eventKey="LTshape" buildingList={LTshapeBuilding} newClass={newClass} isLTShape={true} />
										) : null}

										{rvcoverBuilding.length > 0 ? <BuildingPane eventKey="rvcover" buildingList={rvcoverBuilding}  newClass={newClass} /> : null}

										{freestandingBuilding.length > 0 ? <BuildingPane eventKey="freestanding" buildingList={freestandingBuilding}  newClass={newClass} /> : null}

										<Tab.Pane eventKey="customizations">
											<div className="alert-data pv-30">
												<div className="alert-title">Alert!</div>

												<div className="alert-content">
													<p>Customized buildings are not pre-priced. Sales representatives will determine pricing based on the individual customizations made.</p>
												</div>
											</div>
										</Tab.Pane>
									</Tab.Content>
								</Tab.Container>

								{const_var?.isLTEnableForMfg && const_var?.c_m_a?.[params.p_b_t]?.gable_mapping?.[0]?.map_id && <AddLTExtension />}
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};
export default BuildingStyle;